import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import '../css/button.css';

// Définition des types pour les props
interface buttonProps {
    title: string;
    icon: IconDefinition;
    color: string;
    onClick: () => void;
}

// Composant fonctionnel avec des props typées
const ButtonCustomIcon2: React.FC<buttonProps> = ({ title, icon, color, onClick }) => {
    return (
        <button className="custom-button mx-2" style={{ backgroundColor: color }} onClick={onClick}>
            <span className="button-title">{title}</span>
            <FontAwesomeIcon icon={icon} className="button-icon mx-2" />
        </button>
    );
};

export default ButtonCustomIcon2;
